"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHighVoltageFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M10.934 2h6.329c1.901 0 3.018 2.14 1.933 3.7l-1.977 2.844h1.6c2.093.001 3.066 2.601 1.485 3.975L10 21.48c-1.876 1.63-4.617-.512-3.51-2.724l1.526-3.05H7.13c-1.67 0-2.76-1.744-2.043-3.24l3.71-9.096A2.353 2.353 0 0110.934 2z' }))); };
exports.default = SvgHighVoltageFilled;
//# sourceMappingURL=HighVoltageFilled.js.map